import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import LoadingIndicator from 'Components/UI/LoadingIndicator';
import fr from 'facet-rest';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';

const styles = () => ({
  root: {},
});

const Layout = ({
  className,
  classes,
}) => {
  const { resource } = useMetaLayoutContext();
  const { loadPageContentLink } = usePageContentContext();
  const { clearModalCollection, loadModalCollectionByLink } = useModalContext();

  useEffect(() => {
    if (!resource?.relationship(fr.relationships.goto.name)) {
      return;
    }

    loadPageContentLink(resource.relationship(fr.relationships.goto.name).link('related'));

    // Open the modal from the GoTo query params if we have one
    const gotoUrl = new URL(resource.relationship(fr.relationships.goto.name).link('related').url());
    if (gotoUrl.searchParams.has('modalSelfLink')) {
      const modalSelfLink = gotoUrl.searchParams.get('modalSelfLink');
      loadModalCollectionByLink(modalSelfLink);
    } else {
      clearModalCollection();
    }
  }, [resource.resourceType]);

  return (
    <LoadingIndicator
      className={classNames(classes.root, className)}
    />
  );
};

Layout.defaultProps = {
  className: '',
};

Layout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
